import React from 'react';
import { QuestionEntry } from '@wix/ambassador-faq-question-entry-v2-question-entry/types';
import NumberOneColumn from './NumberOneColumn';

import { useSplitQuestions } from '../../../../../hooks/useSplitQuestions';

const NumberTwoColumns = ({
  filteredQuestions,
}: {
  filteredQuestions: QuestionEntry[];
}) => {
  const {
    leftQuestions,
    rightQuestions,
    indexesLeftQuestions,
    indexesRightQuestions,
  } = useSplitQuestions(filteredQuestions);

  return (
    <>
      <div>
        <NumberOneColumn
          filteredQuestions={leftQuestions}
          indexes={indexesLeftQuestions}
        />
      </div>
      <div>
        <NumberOneColumn
          filteredQuestions={rightQuestions}
          indexes={indexesRightQuestions}
        />
      </div>
    </>
  );
};

export default NumberTwoColumns;
